<template>
<div id="container">
  <div class="locationWrap policy">
    <div>
      <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
      <strong class="inner locTit aniBox type_bot gogo">
        <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>개인정보처리방침
      </strong>
    </div>
  </div>
  <div class="contents">
    <div class="inner">
      <div class="subTitWrap aniBox type_left gogo">
        <h2>개인정보처리방침</h2>
      </div>

      <div class="terms-box" style="height:auto;border:0">
        <h2>제1조 (개인정보의 처리목적)</h2>
        <div class="terms-conditions">
          ① 담다는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br><br>
          1. 홈페이지 회원 가입 및 관리<br>
          회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별&nbsp;·&nbsp;인증, 회원자격 유지&nbsp;·&nbsp;관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종 고지&nbsp;·&nbsp;통지 등을 목적으로 개인정보를 처리합니다.<br>
          2. 수집하는 개인정보의 항목 : 회사명, 이름,  전화번호, 휴대전화번호, 이메일, 직위 등을 수집합니다.<br>
          3. 개인정보 수집방법 : 회원가입자의 작성을 통해 수집합니다.
        </div>
        <h2>제2조 (개인정보의 처리 및 보유기간)</h2>
        <div class="terms-conditions">
          ① 담다는 법령에 따른 개인정보 보유&nbsp;·&nbsp;이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유&nbsp;·&nbsp;이용기간 내에서 개인정보를 처리&nbsp;·&nbsp;보유합니다.<br>
          ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.<br><br>
          1. 홈페이지 회원 가입 및 관리 : 회원가입자(정보주체)가 회원가입을 완료한 날로부터 1년<br>
          다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지<br>
          1) 관계 법령 위반에 따른 수사&nbsp;·&nbsp;조사 등이 진행중인 경우에는 해당 수사&nbsp;·&nbsp;조사 종료시까지<br>
          2) 홈페이지 이용에 따른 채권&nbsp;·&nbsp;채무관계 잔존 시에는 해당 채권&nbsp;·&nbsp;채무관계 정산시까지<br>
          2.「정보통신망 이용촉진 및 정보보호 등에 관한 법률」시행령 제29조에 따른 본인확인정보 보관 : 게시판에 정보 게시가 종료된 후 6개월<br>
          3. 담다는 법령에 따른 개인정보 보유&nbsp;·&nbsp;이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유&nbsp;·&nbsp;이용기간 내에서 개인정보를 처리&nbsp;·&nbsp;보유합니다.
        </div>
        <h2>제3조 (개인정보의 제3자 제공)</h2>
        <div class="terms-conditions">
          ① 담다는 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EtcPrivacyPolicy.vue